import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../button";
import { RouterConstant } from "../../routers/index";
import "./exercise-card.scss";

export interface ExerciseCardProps {
  title: string;
  description: string;
  imgSrc?: string;
  buttonText?: string;
  color: "blue" | "green" | "purple" | "success";
  link?: keyof typeof RouterConstant.ROUTERS_PATH;
  onClick?: () => void; // Optional custom click handler
  price?: number;
}

export default function Index({
  title,
  description,
  imgSrc,
  buttonText,
  color,
  link,
  onClick, // Add optional onClick prop
  price,
}: ExerciseCardProps) {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    if (onClick) {
      onClick(); // Execute custom handler if provided
    } else if (link) {
      navigate(RouterConstant.ROUTERS_PATH[link]); // Default navigation
    }
  };

  return (
    <div className={`exercise-card exercise-card--${color}`}>
      <div className="exercise-card-content">
        <div className="exercise-card-content-wrapper">
          <h5 className="exercise-card-title">{title}</h5>
          {price !== undefined && (
            <div className="exercise-card-price-wrapper">
              <p className={`exercise-card-price exercise-card-price-${color}`}>
                <span className="exercise-card-price-symbol">₪</span>
                {price}
              </p>
            </div>
          )}
        </div>
        <div className="exercise-detail-wrap">
          {imgSrc && (
            <div className="exercise-card-image">
              <img src={imgSrc} alt="exercise" />
            </div>
          )}
          <p>{description}</p>
        </div>
      </div>
      {buttonText && (
        <div className="exercise-card-action">
          <Button
            text={buttonText}
            color={color}
            onClick={handleButtonClick} // Use the wrapper function
          />
        </div>
      )}

    </div>
  );
}